import React from 'react';
// import videojs from 'video.js'
import videojs from "video.js/dist/video.js";
import 'video.js/dist/video-js.css';
import 'videojs-flash';
// import videozhCN from 'video.js/dist/lang/zh-CN.json';
import Reflv from 'reflv'

export default class LiveVideo extends React.Component {

    componentDidMount() {
        // this.player = videojs(this.videoNode, this.props, function onPlayerReady() {

        // });
        // videojs.addLanguage('zh-CN', videozhCN);
    }

    componentWillUnmount() {
        // if (this.player) {
        //     this.player.dispose()
        // } rtmp://106517.livepush.myqcloud.com/live/
    }

    render() {
        return (
            <Reflv
                url={`http://testzb.zhongziyule.com/live/1001.flv`}
                type="flv"
                isLive
                cors
            />
        );
    }
}